@if(virkeskopare$ | async; as virkeskopare){

<form [formGroup]="form" (ngSubmit)="save(virkeskopare)">
    <div class="modal-header">
        <h4 class="modal-title">
            Redigera vikarie
        </h4>
        <button type="button" class="btn-close" aria-label="Close"
            (click)="cancel()"></button>
    </div>
    <div class="modal-body">
        <rask-search
            class="col-6"
            label="Användare"
            bindLabel="namn"
            formControlName="anvandare"
            [typeaheadFn]="searchAnvandareTypeAhead"
            loadingText="Laddar..."
            notFoundText="Ingen träff"
            [minTermLength]="3"
            [selected]="form.controls.anvandare.value">
        </rask-search>
        <rask-search
            class="col-6"
            label="Vikarie"
            bindLabel="namn"
            formControlName="vikarie"
            [typeaheadFn]="searchForAnsvarigPlanerareTypeAhead"
            loadingText="Laddar..."
            notFoundText="Ingen träff"
            [minTermLength]="3"
            [selected]="form.controls.vikarie.value">
        </rask-search>
        <rask-datepicker
            class="col-6"
            label="Från datum"
            formControlName="franDatum">
        </rask-datepicker>
        <rask-datepicker
            class="col-6"
            label="Till datum"
            formControlName="tillDatum">
        </rask-datepicker>
    </div>

    <div class="modal-footer">
        <rask-button
            raskHotkey="ctrl+s"
            type="submit">
            Spara
        </rask-button>
        <rask-button (click)="cancel()">
            Avbryt
        </rask-button>
    </div>
</form>
}